// merge the passed styles into a flat array
export const mergeStyles = (styles) => {
  return Array.prototype.concat.apply([], styles);
};
